import React from 'react';

function DashboardModal({ isOpen, onClose, title, children }) {
    if (!isOpen) return null;

    return (
        <div className="dashboardModal-overlay">
            <div className="dashboardModal-container">
                <div className="dashboardModal-header">
                    <h2>{title}</h2>
                    <button className="dashboardModal-close" onClick={onClose}>×</button>
                </div>
                <div className="dashboardModal-content">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default DashboardModal;